import axios from 'axios';
import router from '@/router/index';
import store from '../store';

axios.defaults.baseURL = 'https://primeroexpress.com/api/';
// axios.defaults.baseURL = 'http://localhost:3000/';
axios.defaults.headers.get.Accepts = 'application/x-www-form-urlencoded';
axios.interceptors.request.use((config) => {
  if (store.state.sesion.logedInUserTokens) {
    config.headers.Authorization = `Bearer ${store.state.sesion.logedInUserTokens.accesstoken}`;
  }
  return config;
}, (error) => Promise.reject(error));
axios.interceptors.response.use(async (response) => {
  if (response.data.INFO.cod === '405' || response.data.INFO.cod === '404') {
    const res = await store.dispatch('sesion/destroyTokens');
    if (res) router.push('login');
  } else if (response.data.INFO.cod === '402') {
    const objetoRefresh = new Object();
    objetoRefresh.Usuario = store.state.sesion.logedInUserInfo.usuario;
    objetoRefresh.RefreshTkn = store.state.sesion.logedInUserTokens.refreshToken;
    const fetchTokens = await store.dispatch('sesion/relogIn', objetoRefresh);
    if (fetchTokens) return await axios.request(response.config);
  }

  return response;
}, (error) => Promise.reject(error));
